// Tripwires (E01-S3-T4; contracts 1.0 section 4): deterministic rules over what the screen shows.
// The Nudge a firing produces is the protocol's shape (E01-S4), not this file's.
import { z } from "zod";
import { Citation } from "./citation.js";
import { ExprField } from "./expr/schema.js";
import { checkTemplateRefs } from "./expr/template.js";
import { Id, NonEmpty, strictObject, version } from "./primitives.js";
import { OpenLoopSpec } from "./sop.js";
export const TripwireSeverity = z.enum(["info", "caution", "stop"]);
/** A step of a procedure, by reference: `ASC-MRG-004#L3`. */
export const SOP_STEP_REF_RE = /^[A-Za-z0-9][A-Za-z0-9._-]*#[A-Za-z0-9][A-Za-z0-9._-]*$/; // <sopId>#<stepId>, both in the id grammar
export const SopStepRef = z
    .string()
    .regex(SOP_STEP_REF_RE, "expected <SOP-ID>#<stepId>, e.g. ASC-MRG-004#L3");
export const TripwireHighlight = strictObject({
    target: Id,
    label: NonEmpty.optional(),
    tone: z.enum(["guide", "caution"]),
});
export const Tripwire = strictObject({
    v: version(1),
    id: Id,
    severity: TripwireSeverity,
    when: ExprField,
    once: z.boolean().optional(),
    text: NonEmpty,
    short: NonEmpty,
    citation: Citation,
    highlight: TripwireHighlight.optional(),
    beat: Id.optional(),
    sopStep: SopStepRef.optional(),
    openLoop: OpenLoopSpec.optional(),
}).superRefine((t, ctx) => {
    // text and short may interpolate allowed frame paths only — no extras (D-04)
    for (const key of ["text", "short"]) {
        for (const e of checkTemplateRefs(t[key], []))
            ctx.addIssue({
                code: "custom",
                message: `tripwire ${t.id}: ${e.code}: ${e.message}`,
                path: [key],
            });
    }
});
//# sourceMappingURL=tripwire.js.map